import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

// Mentions Jalonne sur les pages publiques et dans les emails : badge
// « propulsé par » et white-label complet (emails au nom de l'entreprise).
export default function BrandingSection() {
  const { user } = useAuth();
  const [billing, setBilling] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/billing/status');
      setBilling(data);
    } catch { /* section masquée si erreur */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!billing || user?.role === 'MEMBER') return null;

  const toggle = async (path, body) => {
    try {
      await api.put(path, body);
      load();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur');
    }
  };

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Mentions Jalonne</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {billing.limits.badgeRemovable && (
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.9rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={!!billing.badgeHidden}
              disabled={!!billing.whiteLabel}
              onChange={() => toggle('/billing/badge', { hidden: !billing.badgeHidden })}
            />
            Masquer le badge « propulsé par Jalonne » sur les pages publiques
          </label>
        )}
        {billing.effectivePlan === 'SIGNATURE' && (
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.9rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={!!billing.whiteLabel}
              onChange={() => toggle('/billing/white-label', { enabled: !billing.whiteLabel })}
            />
            White-label complet : aucune mention Jalonne, emails envoyés au nom de votre entreprise
          </label>
        )}
      </div>
    </div>
  );
}
